import { StaticImage } from 'gatsby-plugin-image';
import { useIntl } from 'gatsby-plugin-react-intl';
import * as React from 'react';
import { useSiteMetadata } from '../../../../hooks/useSiteMetadata';
import * as styles from './eu-program-3.module.scss';

export const EuProgram3 = () => {
  const intl = useIntl();
  const { siteMainLang } = useSiteMetadata();

  if (intl.locale !== siteMainLang) {
    return null;
  }

  return (
    <div id="eu-program-3" className={styles.euProgram}>
      <StaticImage
        src="../../../../images/about-us/Plakat-2026.png"
        placeholder="tracedSVG"
        loading="lazy"
        width={800}
        quality={95}
        formats={['auto', 'webp', 'avif']}
        alt={intl.formatMessage({ id: 'about_us.eu_program_3.image.alt' })}
      />
    </div>
  );
};
